export function formatHours(value: string | number): string {
  if (value !== null && value !== undefined && value !== '') {
    const hourValueAsString: string = value.toString().replace(',', '.');
    const isMoreThanOneDot: boolean = hourValueAsString.split('.').length > 2;
    const charRegex = /[^\d.,]/;
    if (
      !hourValueAsString.match(charRegex) &&
      !isMoreThanOneDot &&
      hourValueAsString !== '.' &&
      hourValueAsString !== ''
    ) {
      return parseFloat(hourValueAsString).toFixed(2);
    }
    return value.toString();
  }
  return null;
}
